import request, { authOptions } from 'api/requestUtils'

export async function requestPatchCustomerId(agentId: string, customerId: string): Promise<void> {
  await request.patch(`/api/agent/user/${agentId}/member-id`, {
    customerId,
  }, authOptions())
}
